import { render, staticRenderFns } from "./VSelectRangeInputV2.vue?vue&type=template&id=2ca0e4ec&scoped=true&"
import script from "./VSelectRangeInputV2.vue?vue&type=script&lang=js&"
export * from "./VSelectRangeInputV2.vue?vue&type=script&lang=js&"
import style0 from "./VSelectRangeInputV2.vue?vue&type=style&index=0&id=2ca0e4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0e4ec",
  null
  
)

export default component.exports